import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { AnalyticsService } from '@services/analytics.service';
import { LoginService } from '@services/login.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'TiendaClaveW';

  constructor(
    private loginService: LoginService,
    private analytics: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    if (isPlatformBrowser(this.platformId) && window.location.hash.startsWith('#/')) {
      const cleanPath = window.location.hash.slice(1);
      window.history.replaceState(null, '', cleanPath || '/');
    }
    if (isPlatformBrowser(this.platformId)) {
      this.analytics.init();
    }
  }
}
